"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var locale_1 = require("../i18n/locale");
var compiler_1 = require("../i18n/compiler");
function jsxFactory(create) {
    var compile = compiler_1.createCompiler({
        inject: {
            __CREATE__: create,
        },
        partOffset: 0,
        before: function () { return '__CREATE__(__parts__[0].type, __parts__[0].props,'; },
        after: function () { return ')'; },
        text: function (text) { return htmlDecode(text) + ","; },
        value: function (part) { return part + ","; },
        selfClose: function (part) { return "__CREATE__(" + part + ".type, " + part + ".props),"; },
        open: function (part) { return "__CREATE__(" + part + ".type, " + part + ".props,"; },
        close: function () { return '),'; },
    });
    var Wrapper = null;
    function jsx(phrase, parts, ctx) {
        var translatePhrase = locale_1.getTranslate(phrase, locale_1.getLang(), ctx);
        var compiledPhrase = compile(translatePhrase);
        return Wrapper
            ? create(Wrapper, { value: function () { return compiledPhrase(parts); } })
            : compiledPhrase(parts);
    }
    jsx['useWrapper'] = function (Cmp) {
        Wrapper = Cmp;
    };
    return jsx;
}
exports.jsxFactory = jsxFactory;
var decoder = document.createElement('i');
var entities = {};
var R_ENTITIES = /&[a-z]+;/g;
function htmlDecode(text) {
    return text.indexOf('&') > -1
        ? text.replace(R_ENTITIES, htmlEntityDecode)
        : text;
}
function htmlEntityDecode(entity) {
    if (!entities.hasOwnProperty(entity)) {
        decoder.innerHTML = entity;
        entities[entity] = decoder.textContent;
    }
    return entities[entity];
}
